import React, { Component } from 'react';
import { Button, Card, Table } from 'react-bootstrap'
import axios from 'axios'
import { connect } from 'react-redux';

class AdminUsers extends Component {
    state = { 
                users: [],

     } 
     componentDidMount(){
                axios.get('/api/user/get/all').then((res) => {
                this.setState({ users: res.data.user})
})
     }
    render() { 
                let users = []
        this.state.users.forEach(user => {
            user.marketingPreferences &&
                users.push(
                    <tr key={user._id}>
                        <td>{user.email}</td>
                        <td>{user.marketingPreferences.email.toString()}</td>
                        <td>{user.marketingPreferences.text.toString()}</td>
                        <td>{user.marketingPreferences.phone.toString()}</td>
                        <td>{user.admin.toString()}</td>
                    </tr>
                )
        })
                let darkmode = this.props.user ? this.props.user.darkmode : true

        return (
            <Card style={{ margin: '30px' }}>
                    <Card.Header className={darkmode ? "darkmode-card-header" : "lightmode-card-header"} style={{ textAlign: 'center' }}>
                        Users
                    </Card.Header>
                    <Card.Body className={darkmode ? "darkmode-card-content" : "lightmode-card-content"} style={{ 'margin': '0px' }} >
                        <Table style={{ 'margin': '0px' }} bordered>
                            <thead>
                                <tr className={darkmode ? "darkmode-card-header" : "lightmode-card-header"}>
                                    <th>Email</th>
                                    <th>Email Coms</th>
                                    <th>Text Coms</th>
                                    <th>Phone Coms</th>
                                    <th>Admin</th>
                                </tr>
                            </thead>
                            <tbody className={darkmode ? "darkmode-card-content" : "lightmode-card-content"}>
                                {users}
                            </tbody>
                        </Table>
                    </Card.Body>
                
                </Card>
        );
    }
}
 

function mapStateToProps(state) {
    return {
        user: state.user
    }
}
function mapDispatchToProps(dispatch) {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminUsers);